import React, { FC } from 'react'
import { TooltipWithBounds } from '@visx/tooltip'
import { Box, Typography } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'
import { TOOLTIP_STYLE } from 'apps/tms/constants/charts'

interface IDataTooltipProps {
  title?: string
  left: number
  top: number
}

const useClasses = makeStyles(({ spacing }) => ({
  tooltipTitle: {
    marginBottom: spacing(1.5),
  },
}))

export const DataTooltip: FC<IDataTooltipProps> = ({ children, left, title, top }) => {
  const classes = useClasses()

  return (
    <TooltipWithBounds style={TOOLTIP_STYLE} top={top} left={left} offsetTop={0}>
      <Box padding={2}>
        <Typography variant='subtitle2' className={classes.tooltipTitle}>
          {title}
        </Typography>
        {children}
      </Box>
    </TooltipWithBounds>
  )
}
